<template>
  <div class="r-cell" :style="{ marginBottom }">
    <div class="r-list r-list-end" v-if="hasTitle || hasArray || !showTitle" :style="{justifyContent: showTitle ? 'space-between': 'flex-end'}">
      <div v-if="showTitle">
        <el-tabs class="flex-block tabs-header" v-if="hasArray" v-model="cellTabActive" @tab-click="handleTab">
          <template v-for='(tab, index) in title' :key='tab.name'>
          <el-tab-pane v-if="title.length === 1" :label="tab.label" :name='tab.name'>
            <template #label>
              <div v-if="type === 'cellTop'" class="tab-item" :style="{'width': `${tab.label.length * 14 + 120}px`}">
                <img :src="index === 0 ? (cellTabActive === tab.name ? tabSltBgFirst : tabNavBgFirst) : (cellTabActive === tab.name ? tabSltBg : tabNavBg)"
                    class="tab-bg" :style="{'width': `${tab.label.length * 14 + 120}px`}">
                <span>{{tab.label}}</span>
              </div>
            </template>
          </el-tab-pane>
          </template>
          <template v-for='(tab, index) in title' :key='tab.name'>
            <el-tab-pane v-if="title.length > 1 && size==='normal'" :label="tab.label" :name='tab.name'>
              <template #label>
                <div v-if="type === 'cellTop'" class="tab-item">
                  <img :src="index === 0 ? (cellTabActive === tab.name ? tabSltBgFirst : tabNavBgFirst) : (cellTabActive === tab.name ? tabSltBg : tabNavBg)"
                      class="tab-bg" :class="index === 0 ? 'tab-first-normal' : 'tab-nav-normal'">
                  <span>{{tab.label}}</span>
                </div>
              </template>
            </el-tab-pane>
          </template>
          <template v-for='(tab, index) in title' :key='tab.name'>
            <el-tab-pane v-if="title.length > 1 && size==='small'" :label="tab.label" :name='tab.name'>
              <template #label>
                <div v-if="type === 'cellTop'" class="tab-item" :style="{'width': index=== title.length -1 ? '137px' : '113px'}">
                  <img :src="index === 0 ? (cellTabActive === tab.name ? tabSltBgFirst : tabNavBgFirst) : (cellTabActive === tab.name ? tabSltBg : tabNavBg)"
                      class="tab-bg" :class="index === 0 ? 'tab-first-small' : 'tab-nav-small'">
                  <span>{{tab.label}}</span>
                </div>
              </template>
            </el-tab-pane>
          </template>
        </el-tabs>
        <div class="r-title" v-else-if="hasTitle">
          <slot name="title">
            <div class="tab-item">
              <img v-if="type === 'cellTop'" :src="tabSltBgFirst" class="tab-bg" :style="{'width': `${tab.label.length * 14 + 50}px`}">
              <span>{{ title }}</span>
            </div>
          </slot>
        </div>
      </div>
      <div class="r-cell-icon">
        <slot name="icon"></slot>
      </div>
    </div>
    <div class="r-list" v-if="hasSubContent">
      <slot name="subContent"></slot>
      <div class="r-fixed-icon" ><slot name="subIcon"></slot></div>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'RCell',
    props: {
      title: [String, Array],
      gutter: {
        type: [String, Number],
        default: 0,
      },
      tabActive: {
        type: [String, Number],
        default: ''
      },
      type: {
        type: String,
        default: 'normal'
      },
      size: {
        type: String,
        default: 'normal'
      },
      showTitle: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      marginBottom() {
        const _marginBottom = String(this.gutter);
        return /px$/.test(_marginBottom) ? _marginBottom : `${_marginBottom}px`
      },
      hasTitle() {
        return (
          !!this.title || !!this.$slots['title']
        );
      },
      hasArray() {
        return (
          Array.isArray(this.title) && (!!this.title || !!this.$slots['title'])
        )
      },
      hasSubContent() {
        return (
          !!this.$slots['subContent']
        )
      },
    },
    data() {
      return {
        tabNavBg: require('@/assets/img/rCell/tab-nav.png'),
        tabNavBgFirst: require('@/assets/img/rCell/tab-first-nav.png'),
        tabSltBg: require('@/assets/img/rCell/tab-slt.png'),
        tabSltBgFirst: require('@/assets/img/rCell/tab-first-slt.png'),
        cellTabActive: '',
      }
    },
    watch: {
      tabActive(val) {
        this.cellTabActive = val
      }
    },
    created(){
      if(this.hasArray && !this.cellTabActive){
        this.cellTabActive = this.title.length > 0 ? this.title[0].name : ''
      }
    },
    methods: {
      handleTab() {
        this.$emit('on-tab', this.cellTabActive);
      },
      setActiveTab(value) {
        this.cellTabActive = value
      }
    }
  }
</script>
<style lang="less">
  .r-cell {
    .tabs-header {
      bottom: 0;
    }
    .el-tabs__item {
      font-size: @font-small !important;
      &.is-active{
        font-weight: bold;
      }
    }
  }
</style>
<style lang="less" scoped>
  .r-cell {
    padding: 0px 15px;
    .r-list {
      display: flex;
      align-items: center;
      height: 50px;
      line-height: 38px;
      padding-left: 15px;
      position: relative;
      .r-title {
        display: flex;
        align-items: center;
        font-size: @font-small;
      }
      .r-cell-icon {
        display: flex;
        align-items: center;
      }
      .r-cell-icon > span, .r-cell-icon > div {
        // margin-right: 20px;
        margin-left: 0 !important;
      }
      .r-cell-icon > .el-button{
        margin-right: 0px;
        margin-left: 0 !important;
      }
      .r-cell-icon > div:last-child {
          margin-right: 0px
      }
      .r-cell-icon:last-child{
        // margin-right: 20px
      }
      .r-cell-icon > .el-button:last-child {
          // margin-right: 20px
      }
      .r-fixed-icon {
        display: -webkit-box;
        position: absolute;
        right: 0;
      }
      .r-fixed-icon {
        display: -webkit-box;
        position: absolute;
        right: 0;
      }
    }
    .r-list-end {
      justify-content: space-between;
    }
  }
  .r-icon {
    //border-right: 1px solid @border-line-color;
    padding: 0 10px;
    &:last-child {
      border-right: 0;
    }
  }

  .cell-top{
    .tab-item{
      height: 34px;
      text-align: center;
      .tab-bg{
        position: absolute;
        z-index: -1;
        height: 34px;
        display: none;
      }
      .tab-first-normal{
        width: 180px; //170px;
      }
      .tab-nav-normal{
        width: 177px; //167px;
      }
      .tab-first-small {
        width: 134px;
      }
      .tab-nav-small{
        width: 133px;
      }
      span{
        //padding-left: 24px; //30px;
        padding: 0 15px;
      }
    }
  }
  // .tab-item {
  //   width: 113px !important;
  //   img {
  //     width: 134px !important;
  //   }
  // }
</style>
